"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioAppSDK = exports.BridgeAppSDK = void 0;
const nanoevents_1 = require("nanoevents");
const api_error_1 = require("./api-error");
const apiHelpers_1 = __importDefault(require("./api/apiHelpers"));
const constant_1 = require("./constant");
const jobs = __importStar(require("./jobs"));
const message_bus_1 = require("./message-bus/message-bus");
const util_1 = require("./util");
/**
 * Basic bridge app SDK (can be used outside studio to communicate with parent frame provider)
 */
class BridgeAppSDK {
    /**
     * @param parentFrameUrl  - The parent frame url
     * @param bus             - The message bus
     */
    constructor(parentFrameUrl, bus = new message_bus_1.MessageBus({ parentFrameUrl })) {
        this.emitter = (0, nanoevents_1.createNanoEvents)();
        this.bus = bus;
        this.bus.subscribe('chainInfoUpdate', (data) => this.handleChainInfoUpdate(data));
        this.bus.subscribe('selectedAddressUpdate', (data) => this.handleSelectedAddressUpdate(data));
        this.disconnectWatcher = (0, util_1.watchPath)((path) => this.bus.fetch('pathChange', { path }));
    }
    handleChainInfoUpdate(chainInfo) {
        const cur = this.chainInfo;
        this.chainInfo = chainInfo;
        if ((cur === null || cur === void 0 ? void 0 : cur.name) !== chainInfo.name) {
            this.emitter.emit('chainChanged', chainInfo);
        }
    }
    handleSelectedAddressUpdate(selectedAddressInfo) {
        const cur = this.selectedAddressInfo;
        this.selectedAddressInfo = selectedAddressInfo;
        if ((cur === null || cur === void 0 ? void 0 : cur.address) !== selectedAddressInfo.address) {
            this.emitter.emit('addressChanged', selectedAddressInfo);
        }
    }
    on(name, callback) {
        return this.emitter.on(name, callback);
    }
    destroy() {
        this.disconnectWatcher();
    }
    fetchChainInfo() {
        return this.bus.fetch('fetchChainInfo');
    }
    ethereum(req) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.bus.fetch('ethereumRPC', req);
        });
    }
}
exports.BridgeAppSDK = BridgeAppSDK;
/**
 * SDK for apps within studio
 * Provides accessors to studio app API's and studio app transaction management
 */
class StudioAppSDK extends BridgeAppSDK {
    constructor(config, bus = new message_bus_1.MessageBus({ parentFrameUrl: constant_1.STUDIO_CLIENT_URL })) {
        super(constant_1.STUDIO_CLIENT_URL, bus);
        this.config = this.createConfig(config);
        this.api = new apiHelpers_1.default(`${this.config.studioApiUrl}/app`, this);
    }
    createConfig(config) {
        const fullConfig = config || {};
        return Object.assign({ studioApiUrl: constant_1.STUDIO_API_URL, assetApiUrl: constant_1.ASSET_API_URL }, fullConfig);
    }
    fetchSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const { jwt, expiresTime, isDevMode } = yield this.bus.fetch('fetchJWT');
            localStorage.setItem(constant_1.STUDIO_APP_JWT, jwt);
            localStorage.setItem(constant_1.STUDIO_APP_JWT_EXPIRES_TIME, expiresTime);
            return {
                jwt,
                expiresTime,
                isDevMode,
            };
        });
    }
    checkRefreshJWT() {
        return __awaiter(this, void 0, void 0, function* () {
            const expiresTime = localStorage.getItem(constant_1.STUDIO_APP_JWT_EXPIRES_TIME);
            if (expiresTime) {
                if (Date.now() - 9000 > parseInt(expiresTime)) {
                    yield this.fetchSession();
                }
            }
        });
    }
    setup() {
        return __awaiter(this, void 0, void 0, function* () {
            const session = yield this.fetchSession();
            const [chainInfo, creator] = yield Promise.all([
                this.fetchChainInfo(),
                this.fetchCurrentCreator(),
            ]);
            this.chainInfo = chainInfo;
            this.creator = creator;
            return {
                isDevMode: session.isDevMode,
                chain: this.chainInfo,
                creator: this.creator,
            };
        });
    }
    teardown() {
        return __awaiter(this, void 0, void 0, function* () {
            localStorage.removeItem(constant_1.STUDIO_APP_JWT);
        });
    }
    isSetup() {
        return !!localStorage.getItem(constant_1.STUDIO_APP_JWT);
    }
    createTransaction(data) {
        this.bus.fetch('createTX', data);
    }
    createJob(job) {
        return this.bus.fetch('createJob', job, {
            onProgress: job.onProgress,
        });
    }
    checkPendingTx(abi, contractAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const job = jobs.checkPendingTx(contractAddress, abi);
            const { context } = yield this.createJob(job);
            return context === null || context === void 0 ? void 0 : context.checkPendingTx;
        });
    }
    fetch(url, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.checkRefreshJWT();
            let headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem(constant_1.STUDIO_APP_JWT)}`,
            };
            if (options === null || options === void 0 ? void 0 : options.headers) {
                headers = Object.assign(Object.assign({}, headers), options.headers);
            }
            const response = yield fetch(`${this.config.studioApiUrl}/app${url}`, {
                method: options === null || options === void 0 ? void 0 : options.method,
                headers,
                body: options === null || options === void 0 ? void 0 : options.body,
            });
            if (!response.ok) {
                let err;
                try {
                    err = yield response.json();
                }
                catch (e) {
                    err = response;
                }
                throw new api_error_1.APIError(response.status, (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : 'Something went wrong', err);
            }
            return response.json();
        });
    }
    assetFetch(url, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let headers = options === null || options === void 0 ? void 0 : options.headers;
            const response = yield fetch(`${this.config.assetApiUrl}${url}`, {
                method: options === null || options === void 0 ? void 0 : options.method,
                headers,
                body: options === null || options === void 0 ? void 0 : options.body,
            });
            return response.json();
        });
    }
    fetchAsset(id) {
        if (!id) {
            throw new Error('No asset id provided');
        }
        return this.fetch(`/asset/${id}`);
    }
    createAsset(instanceId) {
        return this.fetch(`/asset/new/studio-app-${instanceId}`, { method: 'POST' });
    }
    updateAssetMetadata(id, data) {
        if (!id) {
            throw new Error('No asset id provided');
        }
        return this.fetch(`/asset/${id}/metadata`, {
            method: 'POST',
            body: JSON.stringify({
                metadata: data,
                editionCount: 1,
            }),
        });
    }
    updateAssetEdition(id, editionCount) {
        if (!id) {
            throw new Error('No asset id provided');
        }
        return this.fetch(`/asset/${id}/metadata/edition`, {
            method: 'POST',
            body: JSON.stringify({ editionCount }),
        });
    }
    deleteAsset(id) {
        if (!id) {
            throw new Error('No asset id provided');
        }
        return this.fetch(`/asset/${id}`, { method: 'DELETE' });
    }
    /**
     * note: client is temporarily wrapping responses
     * in preparation for future paging. This is done here
     * as doing it on the backend at time of writing
     * is far more involved with due to various downstreams.
     */
    fetchAssetsByInstance(instanceId) {
        return this.fetch(`/asset/all/studio-app-${instanceId}`).then(assets => ({
            meta: {},
            results: assets,
        }));
    }
    fetchAssetsByContract(contractId) {
        if (!contractId) {
            throw new Error('No contract id provided');
        }
        return this.fetch(`/asset/all/contract-${contractId}`).then(assets => ({
            meta: {},
            results: assets,
        }));
    }
    uploadFile(assetId, file) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!assetId) {
                throw new Error('No asset id provided');
            }
            const token = yield this.createUploadToken();
            const formData = new FormData();
            formData.append('file', file);
            return this.assetFetch(`/${constant_1.ASSET_UPLOADER_STUDIO_CLIENT_ID}/asset/${assetId}/upload?token=${token}`, {
                method: 'POST',
                body: formData,
            });
        });
    }
    createUploadToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.fetch('/asset/upload/token', {
                method: 'POST',
            });
            const token = data === null || data === void 0 ? void 0 : data.token;
            if (!token) {
                throw new Error('Could not get upload token');
            }
            return token;
        });
    }
    deleteFile(assetId, fileId) {
        if (!assetId) {
            throw new Error('No asset id provided');
        }
        if (!fileId) {
            throw new Error('No file id provided');
        }
        return this.fetch(`/asset/${assetId}/file/${fileId}`, { method: 'DELETE' });
    }
    createAudience(name, entries, legacy) {
        return this.fetch('/audience', {
            method: 'POST',
            body: JSON.stringify({
                name,
                entries,
                legacy: (typeof legacy === 'undefined') ? false : legacy,
            }),
        });
    }
    updateAudience(id, name, active) {
        if (!id) {
            throw new Error('No audience id provided');
        }
        return this.fetch(`/audience/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({
                name,
                active,
            }),
        });
    }
    fetchAudience(id) {
        if (!id) {
            throw new Error('No audience id provided');
        }
        return this.fetch(`/audience/${id}`);
    }
    fetchAudiences() {
        return this.fetch('/audience/all').then(audiences => ({
            meta: {},
            results: audiences,
        }));
    }
    fetchAudienceMerkleRoot(id) {
        if (!id) {
            throw new Error('No audience id provided');
        }
        return this.fetch(`/audience/${id}/merkleRoot`);
    }
    deleteAudience(id) {
        if (!id) {
            throw new Error('No audience id provided');
        }
        return this.fetch(`/audience/${id}`, { method: 'DELETE' });
    }
    patchInstance(id, data) {
        if (!id) {
            throw new Error('No instance id provided');
        }
        return this.fetch(`/instance/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({ data }),
        });
    }
    putInstance(id, data) {
        if (!id) {
            throw new Error('No instance id provided');
        }
        return this.fetch(`/instance/${id}`, {
            method: 'PUT',
            body: JSON.stringify({ data }),
        });
    }
    fetchInstance(id) {
        if (!id) {
            throw new Error('No instance id provided');
        }
        return this.fetch(`/instance/${id}`);
    }
    fetchInstances() {
        return this.fetch('/instance/all').then(instances => ({
            meta: {},
            results: instances,
        }));
    }
    createInstance(data) {
        return this.fetch('/instance', {
            method: 'POST',
            body: JSON.stringify({ data }),
        });
    }
    deleteInstance(id) {
        if (!id) {
            throw new Error('No instance id provided');
        }
        return this.fetch(`/instance/${id}`, { method: 'DELETE' });
    }
    fetchCurrentCreator() {
        return this.fetch('/creator');
    }
    fetchContract(id) {
        if (!id) {
            throw new Error('No contract id provided');
        }
        return this.fetch(`/contract/${id}`);
    }
    fetchContracts() {
        return this.fetch('/contract/all').then(contracts => ({
            meta: {},
            results: contracts,
        }));
    }
}
exports.StudioAppSDK = StudioAppSDK;
//# sourceMappingURL=sdk.js.map